export const HORACHECKIN = 15

export const HORACHECKOUT = 12

export const ESTADOSHABITACIONES = ['Libre', 'Mantenimiento']

export const ESTADOSRESERVAS = ['Reservada', 'Ocupada', 'Salida', 'Limpieza', 'Completada', 'Cancelada', 'Potencial']

export const ORIGENESRESERVAS = ['Recepcion', 'Pagina', 'Booking']

export const MOTIVOS = ['Negocios y motivos profesionales', 'Vacaciones, recreo y ocio', 'Visitas a familiares y a amigos', 'Edicación y formación', 'Salud y atención medica', 'Religion / Peregrinaciones', 'Compras', 'Transito', 'Otros motivos']

export const FECHACHECKIN = 'fechaCheckIn'

export const FECHACHECKOUT = 'fechaCheckOut'

export const COLECCIONRESERVAS = 'reservas'

export const ESTADOSRESERVASCOMPLETO = [
    {
        nombre: 'Reservada',
        color: '#235892'
    },
    {
        nombre: 'Ocupada',
        color: '#7E7850'
    },
    {
        nombre: 'Salida',
        color: '#7E7850'
    },
    {
        nombre: 'Limpieza',
        color: '#FF7676'
    },
    {
        nombre: 'Completada',
        color: '#BDBDBD'
    },
    {
        nombre: 'Cancelada',
        color: '#818181'
    }
]

export const HABITACIONESEJEMPLO = [
    {
        id: 'ASD1',
        numero: 101,
        piso: 1,
        tipo: 'Doble',
        tarifa: 15000,
        estado: 'Libre'
    },
    {
        id: 'ASD2',
        numero: 102,
        piso: 1,
        tipo: 'Doble',
        tarifa: 16000,
        estado: 'Libre'
    },
    {
        id: 'ASD3',
        numero: 103,
        piso: 1,
        tipo: 'Triple',
        tarifa: 25000,
        estado: 'Libre'
    },
    {
        id: 'ASD10',
        numero: 201,
        piso: 2,
        tipo: 'Doble',
        tarifa: 15000,
        estado: 'Libre'
    },
    {
        id: 'ASD20',
        numero: 202,
        piso: 2,
        tipo: 'Doble',
        tarifa: 15000,
        estado: 'Mantenimiento'
    },
]

export const RESERVACIONESEJEMPLO = [
    {
        id: 'RES1',
        nombres: 'Luis M',
        apellidos: 'Rosero',
        cc: '123546',
        tipoCc: 'C.C',
        idHabitacion: 'ASD1',
        tarifa: 15000,
        tipoHabitacion: 'Doble',
        piso: 1,
        ccPrincipal: '11233',
        estado: 'Reservada'
    },
    {
        id: 'RES10',
        nombres: 'Juan Camilo',
        apellidos: 'Charparizan',
        cc: '123546',
        tipoCc: 'C.C',
        idHabitacion: 'ASD20',
        tarifa: 15000,
        tipoHabitacion: 'Doble',
        piso: 1,
        ccPrincipal: '11233',
        estado: 'Reservada'
    }
]